import { render, staticRenderFns } from "./InstallmentCalculationRestructuringCard.vue?vue&type=template&id=b6ba6278&"
import script from "./InstallmentCalculationRestructuringCard.vue?vue&type=script&lang=js&"
export * from "./InstallmentCalculationRestructuringCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports